module.exports = __webpack_public_path__ + "img/scan-tips.4d00858e.png";